import { AuxiliumComponent } from "../auxilium-component";

export default class ProgressItem extends AuxiliumComponent {
	static observableBooleans = ["active"];

	parsedCallback() {
		this.prepend(document.createElementWithContents("div", null, { className: "progress-item__icon" }));
	}
}
